/**
 * Store SSO bridge helper.
 *
 * Store site (store.noiz.gg) shares login with this app via the httpOnly
 * `.noiz.gg` session cookie set at sign-in. On landing, the store calls
 * /api/v1/auth/session/exchange to mint a store-scoped JWT.
 *
 * The URL carries NO credentials — only:
 *   - sso=1     : tells the store to attempt SSO exchange on load
 *   - source=X  : diagnostic tag (staging / prod / etc.) derived from hostname
 *
 * Because no token is ever placed in the URL, this is safe to attach
 * unconditionally (no logs / Referer / history leakage of secrets).
 */

const STORE_BASE_URL = 'https://store.noiz.gg/';

const getSource = () => {
  try {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
    if (!host) return 'unknown';
    if (host === 'noiz.gg' || host === 'www.noiz.gg') return 'prod';
    const match = host.match(/^([^.]+)\.noiz\.gg$/);
    if (match) return match[1];
    return host;
  } catch (e) {
    return 'unknown';
  }
};

export const getStoreUrl = () => {
  const params = new URLSearchParams({ sso: '1', source: getSource() });
  return `${STORE_BASE_URL}?${params.toString()}`;
};
